import { lazy, Suspense, useContext } from "react"
import ProductOrderDetailStyled, {
  ProductInfoDetail,
} from "components/OrderDetail/ProductOrderConfirm/ProductOrderDetail.styled"
import { IconCancel, IconSpinner } from "theme/common/Icon.styled"
import { ButtonStyled } from "theme/common/Button.styled"
import Skeleton from "react-loading-skeleton"
import { IProductOrderDetail } from "interfaces/IProductOrderDetail"
import { clients } from "webapp-clients/Clients"
import { AuthContext } from "context/context/AuthContext"
import useUserPermissions from "hooks/UseUserPermissions"
import { ResourcePermissionsEnum } from "enums/ResourcePermissionsEnum"

import ProductDetail from "components/Core/ProductBase/ProductDetail"
import { useGetProductInfoByClient } from "hooks/UseGetMultiClient"

const ProductOrderDetail = ({ itemOrder, onClicProcessProduct, source, hideConfirmActions }: IProductOrderDetail) => {
  const Img = lazy(() => import("components/Commons/Image/Image"))

  const {
    state: { user },
  } = useContext(AuthContext)

  const fieldProduct = useGetProductInfoByClient(itemOrder)
  const { permission } = useUserPermissions({ resources: [
    ResourcePermissionsEnum.rejecProduct,
  ] })

  const ProductTransition =
    user?.mainGroup?.id && clients[user.mainGroup.id as keyof typeof clients]?.ProductTransition

  //events
  const handleClickReject = () => {
    if (itemOrder) {
      onClicProcessProduct({
        ...itemOrder,
        isConfirm: false,
      })
    }
  }

  return (
    <>
      <ProductOrderDetailStyled>
        <div className="content-info-product">
          <p className="product-name ">{itemOrder?.name || <Skeleton width={200} />}</p>
          <ProductInfoDetail>
            {itemOrder?.custom?.thumbnail && (
              <Suspense fallback={null}>
                <Img alt={itemOrder?.name} url={itemOrder?.custom?.thumbnail} />
              </Suspense>
            )}
            <div className="info">
              <ProductDetail fields={fieldProduct} />
            </div>
          </ProductInfoDetail>

          {ProductTransition && !hideConfirmActions && (
            <Suspense fallback={<IconSpinner variant="big" className="content-center" />}>
              <ProductTransition
                itemOrder={itemOrder}
                onClicProcessProduct={onClicProcessProduct}
                source={source}
              />
            </Suspense>
          )}
          {permission[ResourcePermissionsEnum.rejecProduct] && !hideConfirmActions && (
            <>
              {itemOrder ? (
                <ButtonStyled variant="secondary" onClick={handleClickReject}>
                  <IconCancel />
                  <span>Rechazar producto</span>
                </ButtonStyled>
              ) : (
                <Skeleton width={"100%"} count={1} height={44} />
              )}
            </>
          )}
        </div>
      </ProductOrderDetailStyled>
    </>
  )
}

export default ProductOrderDetail
